<template>
    <Row type="container" class="bg-white rounded shadow min-h-screen">
        <RowColumn>
            <div>
                <SearchCollapse :is-bg-white="true" class="mt-4">
                    <div class="grid grid-cols-12 gap-3 p-0">
                        <div class="col-span-10 md:col-span-4 mt-0.5 position-relative pl-0">
                            <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-10 ml-2">
                                {{ $t('product.name') }}
                            </div>
                            <b-form-input
                                v-model="search.product"
                                class="h-11 focus:ring-0 border-gray-300"
                                @keyup.enter="searchProducts"
                            >
                            </b-form-input>
                        </div>

                        <div class="col-span-10 md:col-span-4 mt-0.5 position-relative pl-0">
                            <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-10 ml-2">
                                {{ $t('filter.fromSellingPrice') }}
                            </div>
                            <b-form-input
                                v-model="search.minSellingPrice"
                                class="h-11 focus:ring-0 border-gray-300"
                                type="number"
                                @keyup.enter="searchProducts"
                            >
                            </b-form-input>
                        </div>

                        <div class="col-span-10 md:col-span-4 mt-0.5 position-relative pl-0">
                            <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-10 ml-2">
                                {{ $t('filter.toSellingPrice') }}
                            </div>
                            <b-form-input
                                v-model="search.maxSellingPrice"
                                class="h-11 focus:ring-0 border-gray-300"
                                type="number"
                                @keyup.enter="searchProducts"
                            >
                            </b-form-input>
                        </div>

                        <div class="col-span-10 md:col-span-8 mt-0.5 position-relative pl-0">
                            <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute bottom-8 ml-2">
                                {{ $t('category') }}
                            </div>
                            <TreeCheckBox
                                model-name="category"
                                :model-form="search"
                                :options="this.getProductCategoriesTree"
                                :multiple="false"
                                :no-margin-top="true"
                                class="mr-sm-2 d-flex p-0 mb-2 mb-sm-0"
                            />
                        </div>


                        <div class="col-span-10 md:col-span-4">
                            <button class="bg-main border-0 hover:bg-hoverMain rounded-l h-11 mt-0.5 w-50 focus:outline-none">
                                <img src="/images/search1.png" alt="" class="h-6 cursor-pointer" @click="searchProducts">
                            </button>
                            <button class="bg-main border-0 hover:bg-hoverMain rounded-r h-11 mt-0.5 w-50 focus:outline-none">
                                <img src="/images/eraser%20(2).png" alt="" class="h-6 cursor-pointer" @click="resetProductSearchInfo">
                            </button>
                        </div>
                    </div>
                </SearchCollapse>
            </div>
        </RowColumn>

        <RowColumn>
            <TableTag class="w-full"
                getter-name="getProducts"
                :headers="[
              {name: 'id', hideOnMobile: true },
              'product.title',
              {name: 'image.title', hideOnMobile: true },
              'sellingPrice',
              {name: 'category', hideOnMobile: true },
              'actions'
              ]"
                :body-properties="[
              {name: 'id', hideOnMobile: true },
              'custom',
              {name: 'picture', hideOnMobile: true },
              sellingPrice,
              {name: findCategoryName, hideOnMobile: true },
              'actions'
              ]"
            >

                <template v-slot:custom="row">
                    <router-link :to="$i18nHelper.getUrl('products/' + row.item.id)" class="font-bold">
                        {{ row.item.name }}
                    </router-link>
                </template>

                <template v-slot:picture="row">
                    <img
                        :src="row.item.image ? url + row.item.image.contentUrl : ''"
                        height="34px"
                        alt=""
                        @click="setModal(row.item.name, url + row.item.image.contentUrl)"
                    >
                </template>

                <template v-slot:actions="row">
                    <img v-if="canPurchaseProducts()" src="/images/add%20(1).png" alt="" class="h-5" @click="$i18nHelper.toUrl('products/' + row.item.id +'/purchase/')">
                    <img src="/images/edit.png" alt="" class="h-5 px-2" @click="$i18nHelper.toUrl('products/' + row.item.id)">
                    <img  v-if="canManageProducts()" src="/images/Union.png" alt="" class="h-5" @click="$bvModal.show('delete-product-' + row.item.id)">

                    <Modal
                        :hide-header="false"
                        :title="$t('warning')"
                        text="deleteConfirm"
                        ok-text="yes"
                        cancel-text="no"
                        :is-ok-only="false"
                        :context="{name: row.item.name}"
                        :id="'delete-product-' + row.item.id"
                        :on-ok-pressed="() => {modalOk(row.item.id)}"
                    />


                </template>
            </TableTag>
        </RowColumn>

        <ModalWithPicture id="show_picture" :img="itemImageUrl" :title="itemName"/>

        <PaginationRow
            class="mt-4 ml-3"
            :search="search"
            base-url="products"
            method-name="searchProduct"
            :total-items="getProductsTotalCount"
        />
    </Row>
</template>

<script>
import currencyFormat from "../../mixin/currencyFormatMixin";
import ModalWithPicture from "../../components/html/ModalWithPicture";
import Row from "../../components/html/Row";
import RowColumn from "../../components/RowColumn";
import TableTag from "../../components/html/TableTag";
import PaginationRow from "../../components/PaginationRow";
import {mapActions, mapGetters} from "vuex";
import accessMixin from "@/mixin/accessMixin";
import Modal from "@/components/html/Modal";
import SearchCollapse from "@/components/SearchCollapse";
import TreeCheckBox from "@/components/TreeCheckBox";

export default {
    name: "ProductsList",
    components: {
        PaginationRow,
        TableTag,
        ModalWithPicture,
        RowColumn,
        Row,
        Modal,
        SearchCollapse,
        TreeCheckBox
    },
    mixins: [currencyFormat, accessMixin],
    data() {
        return {
            modalName: '',
            itemName: '',
            itemImageUrl: '',
            url: process.env.VUE_APP_API_URL,
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'warehouse.title', url: 'warehouses'},
                {name: 'product.title'},
            ],
            search: {
                product: '',
                minSellingPrice: '',
                maxSellingPrice: '',
                category: null,
                page: 1
            },
        }
    },
    computed: mapGetters(['getProductsTotalCount', 'getProduct', 'getProductCategory', 'getProductCategoriesTree', 'getUserCompanyId']),
    methods: {
        ...mapActions([
            'fetchCurrencies',
            'deleteProduct',
            'fetchProducts',
            'searchProduct',
            'fetchProductCategory',
            "fetchProductCategoriesTree",
            'setBreadcrumbItems',
            'fetchUser'
        ]),
        setModal(name, url) {
            this.itemName = name
            this.itemImageUrl = url
            this.$bvModal.show('show_picture')
        },
        sellingPrice(item) {
            return this.showCurrencyById(item.sellingPriceCurrency.id, item.sellingPrice)
        },
        modalOk(id) {
            this.deleteProduct(id)
                .then(() => {
                    this.fetchProducts()
                })
        },
        searchProducts() {
            this.$root.showOverlay = true
            this.search.isPurchaseProductPage = false
            this.searchProduct(this.search)
                .catch((err) => {
                    console.log(err)
                })
                .finally(() => {
                    this.$root.showOverlay = false
                });
        },
        resetProductSearchInfo() {
            Object.assign(this.$data, this.$options.data.call(this));
            this.searchProducts()
        },
        findCategoryName(item) {
            let category = []

            item.categories.forEach((value) => {
                category.push(value.name)
            })

            let categoryName = ''

            for (let i = 0; i < category.length; i++) {
                categoryName = categoryName + category[i] + ' '
            }

            return categoryName
        },
    },
    created() {
        this.$root.showOverlay = true
        this.setBreadcrumbItems(this.breadcrumbItems)
        this.search.companyId = this.getUserCompanyId

        if (!this.search.companyId) {
            this
                .fetchUser()
                .then(() => {
                    this.search.companyId = this.getUserCompanyId
                    this.searchProduct(this.search)
                    this.$root.showOverlay = false
                })
                .catch(() => {
                    this.$root.showOverlay = false
                })
        }
    },
    beforeMount() {
        this.fetchCurrencies();
    },
    mounted() {
        this.fetchProductCategoriesTree()

    },
}
</script>

<style scoped>
.form-control {
    margin-bottom: 5px !important;
}

.mb-3 {
    margin-bottom: -16px !important;
}

img {
    cursor: pointer;
}
</style>
